import { useSavedBrokersApi } from "@/Hooks/useSavedBrokersApi";
import type { UUID } from "@/Shared/types";
import type {
  AddSavedBrokerOperationRequest,
  DeleteSavedBrokerOperationRequest,
  ModifySavedBrokerOperationRequest,
  SetPreferredRequest,
} from "@freightsimple/generated-dashboard-openapi-client/apis/SavedBrokersApi";
import type { Broker } from "@freightsimple/generated-dashboard-openapi-client/models/Broker";
import type { PreferredBrokerType } from "@freightsimple/generated-dashboard-openapi-client/models/PreferredBrokerType";
import type { SavedBroker } from "@freightsimple/generated-dashboard-openapi-client/models/SavedBroker";

export function useSavedBrokersService() {
  const savedBrokersApi = useSavedBrokersApi();

  return {
    addBroker: async function (broker: SavedBroker) {
      const request: AddSavedBrokerOperationRequest = {
        addSavedBrokerRequest: {
          broker,
        },
      };

      await savedBrokersApi.addSavedBroker(request);
    },

    modifyBroker: async function (brokerId: UUID, broker: Broker) {
      const request: ModifySavedBrokerOperationRequest = {
        modifySavedBrokerRequest: {
          savedBrokerId: brokerId,
          broker: broker as Broker,
        },
      };

      await savedBrokersApi.modifySavedBroker(request);
    },

    deleteSavedBroker: async function (savedBrokerId: UUID) {
      const request: DeleteSavedBrokerOperationRequest = {
        deleteSavedBrokerRequest: {
          savedBrokerId: savedBrokerId,
        },
      };
      await savedBrokersApi.deleteSavedBroker(request);
    },

    setPreferred: async function (
      savedBrokerId: UUID,
      preferredType: PreferredBrokerType,
    ) {
      const request: SetPreferredRequest = {
        setPreferredBrokerRequest: {
          savedBrokerId,
          preferredType,
        },
      };

      await savedBrokersApi.setPreferred(request);
    },
  };
}
